export default __webpack_public_path__ + "static/media/go.7242377a.svg";